import React from 'react';
import { Trans } from 'react-i18next';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Paragraph from 'components/Paragraph';
import { modalStore } from 'apps/modals/app';

import { EditLicenseForm } from 'apps/project/views/editLicenseForm';
import { Button, Icon, Tooltip } from 'components';
import {
  ProjectInfoTerm,
  ProjectInfoDef,
  ProjectInfoFullRow,
} from 'apps/project/views/overview.styles';

import { ExternalLink } from 'core/routing';
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from '@chakra-ui/react';
@observer
export class License extends React.Component {
  clickLicense = () => {
    this.props.app.EditLicense();
    modalStore.SetModalComponent(EditLicenseForm, {
      projectApp: this.props.app,
    });
  };

  render() {
    const { app, repoManager } = this.props;
    const { editing, license, showingLicenseDetails } = app;

    // FIXME: Move dt dd elements outside of license into overview.js
    if (editing) {
      return (
        <>
          <ProjectInfoTerm>License</ProjectInfoTerm>
          <ProjectInfoDef>
            {license === null || license.name === '' ? (
              <EditingLicenseStyled
                onClick={this.clickLicense}
                text='Add Licence'
                variant='secondary'
                size='small'
                appearance='plain'
                icon='add'
              />
            ) : (
              <EditingLicenseStyled
                onClick={this.clickLicense}
                text={license.title}
                variant='secondary'
                size='small'
                appearance='plain'
                icon='pen'
              />
            )}
          </ProjectInfoDef>
        </>
      );
    }

    const licenseTitle = (
      <>
        <LicenseStyled
          data-tip='Learn more about this open source license'
          invisible={editing}
          text={license ? license.abreviation : 'XX'}
          appearance='plain'
          // onClick={app.ToggleLicenseDetailsView}
          variant='tertiary'
          // icon={showingLicenseDetails ? 'caret_down' : 'caret_up'}
        />
      </>
    );

    const permissions = app.licenseLimits.permissions.map((item, i) => {
      return (
        <LicenseEntry key={`perm-${i}`}>
          <EntryIcon name='success' />
          <LabelP>{item.replace('-', ' ')}</LabelP>
        </LicenseEntry>
      );
    });
    const limitations = app.licenseLimits.limitations.map((item, i) => {
      return (
        <LicenseEntry key={`limi-${i}`}>
          <EntryIcon name='error' stroke='light' />
          <LabelP>{item.replace('-', ' ')}</LabelP>
        </LicenseEntry>
      );
    });

    const conditions = app.licenseLimits.conditions.map((item, i) => {
      return (
        <LicenseEntry key={`cond-${i}`}>
          <LabelP>{item.replace('-', ' ')}</LabelP>
        </LicenseEntry>
      );
    });

    if (repoManager.routerStore.path.split('/')[1] !== '+opennext') {
      if (license) {
        return (
          <>
            <ProjectInfoTerm>License</ProjectInfoTerm>
            <ExternalLink to={license.url}>
              <Tooltip delayShow={500} />

              <ProjectInfoDef>{license ? licenseTitle : 'n/A'}</ProjectInfoDef>
            </ExternalLink>
          </>
        );
      }
      return (
        <>
          <ProjectInfoTerm>License</ProjectInfoTerm>
          <ProjectInfoDef>{'n/A'}</ProjectInfoDef>
        </>
      );
    }

    return (
      <StyledLicenseAccordion
        allowToggle
        ref={this.accordionRef}
        onChange={() => {
          app.ToggleLicenseDetailsView();
        }}
      >
        <AccordionItem>
          <StyledAccordionHeader>
            <AccordionButton>
              <ProjectInfoTerm style={{ paddingLeft: '0.5em' }}>
                License{' '}
                <Icon
                  name={showingLicenseDetails ? 'caret_down' : 'caret_up'}
                  style={{ transform: 'translateY(-0.2em)' }}
                ></Icon>
              </ProjectInfoTerm>
            </AccordionButton>
            <ProjectInfoDef>{license ? licenseTitle : 'n/A'}</ProjectInfoDef>
          </StyledAccordionHeader>

          <AccordionPanel pb={4}>
            {app.licenseLimits && (
              <ProjectInfoFullRow>
                <Paragraph size='small'>
                  <Trans>{app.licenseLimits.description}</Trans>
                </Paragraph>
                <LicenseCategoriesSection>
                  <PermissionsList>
                    <EntryHeader>Permissions</EntryHeader>
                    {permissions.length > 0 ? permissions : '?'}
                  </PermissionsList>

                  <LimitationsList>
                    <EntryHeader>Limitations</EntryHeader>
                    {limitations.length > 0 ? limitations : '?'}
                  </LimitationsList>

                  <ConditionsList>
                    <EntryHeader>Conditions</EntryHeader>
                    {conditions.length > 0 ? conditions : '?'}
                  </ConditionsList>
                </LicenseCategoriesSection>
              </ProjectInfoFullRow>
            )}
          </AccordionPanel>
        </AccordionItem>
      </StyledLicenseAccordion>
    );
  }
}

License.propTypes = {
  app: PropTypes.object,
};

const LicenseStyled = styled(Button)`
  opacity: ${props => (props.invisible ? '0' : '1')};
  padding: 0;
`;

const EditingLicenseStyled = styled(LicenseStyled)`
  font-weight: ${props => props.theme.font.weight.regular};
  color: ${props => props.theme.color.wfBlue};
`;

const LicenseCategoriesSection = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: 2em;
`;

const EntryHeader = styled.p`
  font-weight: normal;
`;

const PermissionsList = styled.div`
  grid-column: 1;
`;
const LimitationsList = styled.div`
  grid-column: 2;
`;
const ConditionsList = styled.div`
  grid-column: 3;
`;

const LicenseEntry = styled.div``;

const EntryIcon = styled(Icon)`
  transform: translateY(-3px);
`;

const LabelP = styled.p`
  display: inline-block;
  text-transform: capitalize;
  font-weight: normal;
  opacity: 0.5;
  margin-left: 0.3em;
`;

const StyledAccordionHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
const StyledLicenseAccordion = styled(Accordion)`
  grid-column: 1 / span 2;
`;
